module.exports = __webpack_public_path__ + "static/google-play-icon-c7d33af553a249716c22e0f64fcbb1ee.png";